import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../components/Spinner';
import { useCompanyIdFromProcoreCompanyId } from '../../../../services/company-service';
import ProjectRecords from '../ProjectRecords';

const ProjectRecordsContainer = ({ procoreCompanyId, procoreProjectId }) => {
  const { data: pinsCompanyId, isLoading: companyIdIsLoading } = useCompanyIdFromProcoreCompanyId(procoreCompanyId);

  if (companyIdIsLoading) {
    return (
      <Box>
        <LoadingSpinner minHeight="300px" />
      </Box>
    );
  }

  if (!pinsCompanyId) {
    return (
      <Box>
        <Text>{`No PINS company id integrated with Procore Company Id: ${procoreCompanyId}`}</Text>
      </Box>
    );
  }

  return (
    <ProjectRecords pinsCompanyId={pinsCompanyId} procoreProjectId={procoreProjectId} />
  );
};

ProjectRecordsContainer.propTypes = {
  procoreCompanyId: PropTypes.number.isRequired,
  procoreProjectId: PropTypes.number.isRequired
};

export default ProjectRecordsContainer;
